import React, { useState, useContext } from "react";
import Swal from "sweetalert2";

import AuthService from "../../../../services/Admin/AuthService";
import CompanyService from "../../../../services/Admin/CompanyService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

const SliderImages = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const [sliderImages, setSliderImages] = useState(
    props.data.slider_images || []
  );

  const [utiSliderImages, setUtiSliderImages] = useState(
    props.data.uti_slider_images || []
  );

  const updateHandler = async () => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await CompanyService.updateSliderImages(
        token,
        sliderImages,
        utiSliderImages
      );

      if (responseData.status === "SUCCESS") {
        Swal.fire("Success!", responseData.message, "success");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire("Oops!", HttpError.getError(error), "error");
    }

    loadingCtx.stopLoading();
  };

  const renderSliderCard = (title, images, setImages) => (
    <div className="card bg-light d-flex flex-fill mb-3">
      <div className="card-header text-muted border-bottom-0">
        <h3 className="card-title">{title}</h3>
        <div className="card-tools">
          <button
            type="button"
            className="btn btn-info btn-sm"
            onClick={() =>
              setImages([...images, { image_link: "", target_link: "" }])
            }
          >
            <i className="fas fa-plus"></i> Add
          </button>
        </div>
      </div>

      <div className="card-body pt-0 mb-2">
        {images.map((item, index) => (
          <div className="row pt-2" key={index}>
            <div className="col-5">
              <label>Image (Link)</label>
              <input
                type="text"
                className="form-control"
                value={item.image_link}
                onChange={(e) => {
                  const updated = [...images];
                  updated[index].image_link = e.target.value;
                  setImages(updated);
                }}
              />
            </div>

            <div className="col-5">
              <label>Target (Link)</label>
              <input
                type="text"
                className="form-control"
                value={item.target_link}
                onChange={(e) => {
                  const updated = [...images];
                  updated[index].target_link = e.target.value;
                  setImages(updated);
                }}
              />
            </div>

            <div className="col-2">
              <button
                type="button"
                className="btn btn-danger btn-sm"
                style={{ marginTop: "34px" }}
                onClick={() => setImages(images.filter((_, i) => i !== index))}
              >
                <i className="far fa-trash-alt"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="row">
      <div className="col-md-10 mx-auto">
        {renderSliderCard("Slider Images", sliderImages, setSliderImages)}

        {renderSliderCard(
          "UTI Slider Images",
          utiSliderImages,
          setUtiSliderImages
        )}

        <div className="text-center">
          <button
            type="button"
            className="btn btn-primary"
            onClick={updateHandler}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default SliderImages;
